
 console.log("asdfasdf");
  var select2 = false;
  var locations =[];
  var citiesMap =[];  
  var neighborhoodMap =[];
  var selectProvices = document.getElementById('provincesSelect');
  var selectCities = document.getElementById('cities');
  var selectNeighborhoods = document.getElementById('neighborhoods');    
  var inputDocument = document.getElementById('documentNumber');
  var inputCityName = document.getElementById('cityName');
  var inputProvinceName = document.getElementById('provinceName');
  var inputNeighborhoodName = document.getElementById('neighborhoodName');   
  var inputNeighborhood = document.getElementById('neighborhoodsInput');

  selectProvices.addEventListener('change', (event) => {
    var fn = function(item){
      neighborhoodMap[item.cityId] = item.neighborhoods;
    };

    console.log(selectProvices.value);

    renderSelect("cityId", "cityName", citiesMap[selectProvices.value], selectCities, fn);
    
    inputProvinceName.value = selectProvices.options[selectProvices.selectedIndex].text;
  });

  selectCities.addEventListener('change', (event) => {
    if(selectCities.value){
      console.log(selectCities.value);
      selected2Render(neighborhoodMap[selectCities.value]);
      inputCityName.value = selectCities.options[selectCities.selectedIndex].text;
      
      console.log(neighborhoodMap[selectCities.value]);
      var  neighborhood = neighborhoodMap[selectCities.value][0];
      setFormParameters();
      inputNeighborhood.value = neighborhood.id;
      inputNeighborhoodName.value = inputCityName.value;
     }
  });



  inputDocument.addEventListener('change', (event) => {
    setFormParameters();
  });

  locations = window.sessionStorage.locations;
  locations = locations == null? []:JSON.parse(locations);

  if(locations.length == 0){
    fetch('https://cdn.shopify.com/s/files/1/0820/9255/6521/files/ciudades-municipos-colombia.json?v=1786557726')
    .then(r => r.json())
    .then(data => {
      var fn = function(item){
        citiesMap[item.provinceId] = item.cities;
      };
      locations=data;

      console.log(data);

      renderSelect("provinceId", "provinceName", data, selectProvices, fn);
      window.sessionStorage.locations =JSON.stringify(locations);
    });
  }
  else{
    var fn = function(item){
      citiesMap[item.provinceId] = item.cities;
    };

    renderSelect("provinceId", "provinceName", locations, selectProvices, fn);
  }

  function setFormParameters(){
    var cityCode =selectCities.options[selectCities.selectedIndex].value;
    var proviceId =selectProvices.value;
    var city =selectCities.options[selectCities.selectedIndex].text;
    var documentNumber = inputDocument.value;
    var form = document.getElementById('cart');
    var postUrl =  form.action;
    var connector = postUrl.includes("?") ? "&" : "?";

    connector ="?";
    postUrl ="/cart";
    postUrl += connector + "checkout[shipping_address][company]=" + documentNumber;      
    postUrl += "&checkout[shipping_address][country_code]=CO";
    postUrl += "&checkout[shipping_address][province_code]="+ proviceId;
    postUrl += "&checkout[shipping_address][city]="+  city;
    postUrl += "&checkout[shipping_address][zip]="+  cityCode;

    form.action = postUrl;
  }

  function selected2Render(data) {
    var dataJs = [];
    if (select2) {
      $('#neighborhoods').select2('destroy');
      $('#neighborhoods').html("");
      $('#neighborhoods').unbind();
    }
    
 dataJs.push({
        "id": null,
        "text": "Seleccione..."
      });
    
    $.each(data, function (i, item) {
      dataJs.push({
        "id": item.id,
        "text": item.neighborhood
      });
    });

    $("#neighborhoods").select2({
      data: dataJs,
      placeholder: "Seleccione...",
      pagination: {
        more: true
      },
      "language": {
        "noResults": function () {
          return "No se encontraron resultados";
        }
      }
    });

    $('#neighborhoods').on('select2:select', function (e) {
      var data = e.params.data;
      console.log(data);
      inputNeighborhoodName.value = data.text;      
      inputNeighborhood.value = data.id;

      setFormParameters();
    });

    $("#neighborhoods").val(null).trigger("change");
    select2 = true;
  };

  function renderSelect(id, text, data, element, fn){
    var length = element.options.length;

    for (i = length-1; i >= 0; i--) {
      element.options[i] = null;
    }

    if(id == "cityId"){
      var option = document.createElement("option");

      option.text = "Seleccione...";  
      option.value = "";
      element.add(option);
    }

    for(var i=0; i < data.length; i++){
      const item = data[i];
      var option = document.createElement("option");

      option.text = item[text];  
      option.value = item[id];
      element.add(option);

      if(fn != null){
        fn(item);
      }
    }

    element.dispatchEvent(new Event('change'));
  }


  selected2Render([]);
